import store from '@/store/index';
const tenantCode = store.getters.currentTenant.tenantCode;
export default {
    'searchList': {
        'searchTxt': [{
            'name': '结算申请单号',
            'value': 'apApplyNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        },
        {
            'name': '发票号',
            'value': 'invoiceNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        },
        {
            'name': '创建时间',
            'value': 'createTime',
            'startTime': 'createTimeFrom',
            'endTime': 'createTimeTo',
            'type': 'time',
            'timeNum': 7,
            'unfold': true,
            'span': 6
        },
        {
            'name': '收款状态',
            'value': 'payStatus',
            'type': 'select',
            'unfold': true,
            'span': 2,
            'data': '10',
            'optionNum': 'SYS_BMS_AP_PAYMENT_STAT_SUPP',
            'multiple': false
        },
        {
            'name': '单据状态',
            'value': 'statusArray',
            'type': 'select',
            'unfold': true,
            'span': 4,
            'optionNum': 'SYS_BMS_AP_APPLY_STATUS_SUPP',
            'filterable': true,
            'multiple': true
        },
        {
            'name': '发票状态',
            'value': 'invoiceStatus',
            'type': 'select',
            'unfold': true,
            'span': 3,
            'data': '10',
            'optionNum': 'SYS_BMS_APPLY_INVOICE_STATUS',
            'multiple': false
        }
        ],
        'unfoldState': false,
        'advancedBtn': true
    },
    'searchTotalTitle': [
        {
            'name': '服务平台',
            'value': 'siteName',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' },
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' }
            ],
            'tableConfig': [
                { 'prop': 'escoCompanyNo', 'value': '服务平台编码' },
                { 'prop': 'escoCompanyNameCn', 'value': '服务平台名称' }
            ],
            'advanceUrl': '/searchPlatform',
            'type': 'advance',
            'cbParams': ['escoCompanyNo#siteCode', 'escoCompanyNameCn#siteName'],
            'span': 3
        },
        {
            'name': '分公司',
            'value': 'companyNameNew',
            'unfold': true,
            'advanceConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCodeNew', 'value': '分公司编码' }
            ],
            'tableConfig': [
                { 'prop': 'companyNameCn', 'value': '分公司名称' },
                { 'prop': 'companyCodeNew', 'value': '分公司编码' }
            ],
            'advanceUrl': '/esCompany/popCompany',
            'type': 'advance',
            'cbParams': ['companyCode#companyCodeNew', 'companyNameCn#companyNameNew'],
            'span': 3
        },

        // {
        //     'name': '客户名称',
        //     'value': 'ledgerName',
        //     'type': 'input',
        //     'unfold': true,
        //     'span': 3
        // },
        {
            'name': '客户名称',
            'value': 'accountName',
            'advanceLabel': '客户名称',
            'type': 'advance',
            'advanceConfig': [
                { 'prop': 'operatingUnitName', 'value': '客户名称' },
                { 'prop': 'operatingUnitId', 'value': '客户编码' }
            ],
            'tableConfig': [
                { 'prop': 'operatingUnitName', 'value': '客户名称' },
                { 'prop': 'operatingUnitId', 'value': '客户编码' },
                { 'prop': 'companyName', 'value': '公司名称' }
            ],
            'cbParams': ['operatingUnitName#accountName#companyName', 'operatingUnitId#ledgerId'],
            'advanceUrl': '/common/anntoFeeHead/efOrganRelation/page?enabledFlag=1&tenantCode=' + tenantCode,
            'prefix': 'api-bcp-web'
        },
        // {
        //     'name': '客户名称',
        //     'value': 'BMS_ACCOUNT_ENTITY',
        //     'unfold': true,
        //     'advanceConfig': [
        //         { 'prop': 'companyNameCn', 'value': '主体编码' },
        //         { 'prop': 'operatingUnitName', 'value': '主体名称' },
        //         { 'prop': 'companyName', 'value': '公司名称' }
        //     ],
        //     'tableConfig': [
        //         { 'prop': 'operatingUnitId', 'value': '主体编码' },
        //         { 'prop': 'operatingUnitName', 'value': '主体名称' },
        //         { 'prop': 'companyName', 'value': '公司名称' },
        //         { 'prop': 'enableMark', 'value': '状态' }
        //     ],
        //     'advanceUrl': '/esCompany/popCompany',
        //     'type': 'advance',
        //     'cbParams': ['companyCode#companyCode', 'companyNameCn#companyName'],
        //     'span': 3
        // },
        {
            'name': '账单号',
            'value': 'apBillNo',
            'type': 'input',
            'unfold': true,
            'span': 3
        }

    ],
    'table':
    {
        'clickState': false,
        'selectBtn': true,
        'height': 400,
        'fixedSeletionColumn': true,
        'columns': [
            {
                'label': '结算申请单号',
                'prop': 'apApplyNo',
                'width': '148px'
            },
            {
                'label': '分公司',
                'prop': 'companyNameNew',
                'width': '100px'
            },
            {
                'label': '客户名称',
                'prop': 'ledgerName',
                'width': '260px'
            },
            {
                'label': '单据状态',
                'prop': 'statusText',
                'width': '80px'
            },
            {
                'label': '发票状态',
                'prop': 'invoiceStatusText',
                'width': '80px'
            },
            {
                'label': '收款状态',
                'prop': 'payStatusText',
                'width': '80px'
            },
            {
                'label': '应收款金额',
                'prop': 'apRealAmt',
                'width': '110px'
            },
            // {
            //     'label': '已付款金额',
            //     'prop': 'totalAmt',
            //     'width': '100px'
            // },
            {
                'label': '应开票金额',
                'prop': 'invoiceAmt',
                'width': '80px'
            },
            {
                'label': '备注',
                'prop': 'remark',
                'width': '220px'
            },
            {
                'label': '创建时间',
                'prop': 'createTime',
                'width': '160px'
            },
            {
                'label': '快递单号',
                'prop': 'courierNo',
                'width': '160px'
            },
            {
                'label': '账单号',
                'prop': 'apBillNo',
                'width': '160px'
            }
        ],
        'leftOperation': false
    },
    'page': {
        'layout': 'total, sizes, prev, pager, next, jumper',
        'pageSize': 10
    }
};
